// Google Analytics helper functions

// Track page views
export const trackPageView = (path) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('config', 'G-ZJHRNJ63XH', {
            page_path: path
        });
    }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window.gtag !== 'undefined') {
        window.gtag('event', eventName, eventParams);
    }
};

// Specific event tracking functions

export const trackQuizCompletion = (quizTitle, score, total, passed, attemptNumber) => {
    trackEvent('quiz_completed', {
        quiz_title: quizTitle,
        score: score,
        total_questions: total,
        percentage: Math.round((score / total) * 100),
        passed: passed,
        attempt_number: attemptNumber
    });
};

export const trackQuizRetake = (quizTitle, previousScore, attemptNumber) => {
    trackEvent('quiz_retaken', {
        quiz_title: quizTitle,
        previous_score: previousScore,
        attempt_number: attemptNumber
    });
};

export const trackLogin = (userId) => {
    trackEvent('login', {
        user_id: userId
    });
};

export const trackSignup = (userId) => {
    trackEvent('sign_up', {
        user_id: userId
    });
};

export const trackKnowledgeCreated = (knowledgeType, assessmentType) => {
    trackEvent('knowledge_created', {
        knowledge_type: knowledgeType,
        assessment_type: assessmentType
    });
};

export const trackIntegrationConnected = (integrationType) => {
    trackEvent('integration_connected', {
        integration_type: integrationType
    });
};

export const trackSyncCompleted = (integrationType, pagesProcessed) => {
    trackEvent('sync_completed', {
        integration_type: integrationType,
        pages_processed: pagesProcessed
    });
};
